import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Chip } from "../Chip";
import { FauxInput } from "../FauxInput";
import { Info } from "../Info";

import "./styles.scss";

export const FileInput = ({
  className,
  disabled,
  files,
  infoContent,
  infoPopoverPosition,
  onDelete,
  placeholder,
  ...props
}) => {
  const [stateFiles, setStateFiles] = useState(files);

  useEffect(() => {
    if (files !== stateFiles) {
      setStateFiles(files);
    }
  }, [files]);

  const chipDeleteHandler = (e) => {
    const fileDeleted = e.target.attributes["data-label"].value;

    setStateFiles(stateFiles.filter((file) => file !== fileDeleted));
    onDelete(fileDeleted);
  };

  return (
    <FauxInput
      className={createClassNameString(["apti-FileInput", className])}
      disabled={disabled}
      icon={
        infoContent && (
          <>
            <div className="apti-FileInput--info-container">&nbsp;</div>
            <Info className="apti-FileInput--info" position={infoPopoverPosition}>
              {infoContent}
            </Info>
          </>
        )
      }
      placeholder={placeholder}
      {...props}
    >
      {stateFiles.map((file, index) => (
        <Chip key={index} label={file} onClick={chipDeleteHandler} />
      ))}
    </FauxInput>
  );
};

FileInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  files: PropTypes.arrayOf(PropTypes.string).isRequired,
  infoContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  infoPopoverPosition: PropTypes.oneOf(["left", "right", "top", "bottom"]),
  onDelete: PropTypes.func,
  placeholder: PropTypes.string,
};

FileInput.defaultProps = {
  className: undefined,
  disabled: false,
  files: [],
  infoContent: undefined,
  infoPopoverPosition: "right",
  onDelete: () => {},
  placeholder: "",
};
